import { DESKTOP_QUERY, useMediaQuery } from '@/hooks/useMediaQuery';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '@/app/AuthContext.jsx';
import { useReceptorAnswered, useReceptorInbox } from '@/hooks';
import { errorMessage } from '@/lib';
import { extractList } from '@/lib/apiList';
import SolicitudesInbox from './SolicitudesInbox.jsx';
import SolicitudesHeader from './SolicitudesHeader.jsx';
import { mapQuoteToInboxItem } from './mapQuote.js';

import './SolicitudesInbox.css';

export default function Solicitudes() {
  const navigate = useNavigate();
  // Desktop reads the inbox as a table; mobile keeps the card list.
  const table = useMediaQuery(DESKTOP_QUERY);
  // The heading takes focus once, on mount, to announce the view. Crossing
  // 1024px later must not pull focus away from whatever is being typed.
  const [focusOnMount] = useState(() => table);
  const { organizationId } = useAuth();
  const [params, setParams] = useSearchParams();
  const answered = params.get('vista') === 'respondidas';
  // Both hooks run so the order stays fixed; only the visible one fetches.
  const pendingQuery = useReceptorInbox(organizationId, { enabled: !answered });
  const answeredQuery = useReceptorAnswered(organizationId, {
    enabled: answered,
  });
  const { data, error, isError, isPending } = answered
    ? answeredQuery
    : pendingQuery;
  const search = answered ? '?vista=respondidas' : '';
  const onViewChange = (next) =>
    setParams(
      (prev) => {
        const out = new URLSearchParams(prev);
        if (next) out.set('vista', 'respondidas');
        else out.delete('vista');
        return out;
      },
      { replace: true },
    );
  const items = extractList(data).map(mapQuoteToInboxItem).filter(Boolean);

  const open = (item) => navigate(`/solicitudes/${item.id}${search}`);

  if (isPending) {
    return (
      <SolicitudesInbox
        pending
        table={table}
        focusHeading={focusOnMount}
        answered={answered}
        onViewChange={onViewChange}
      />
    );
  }

  if (isError) {
    return (
      <div className={`sol${table ? ' sol--table' : ''}`}>
        <SolicitudesHeader
          table={table}
          focusHeading={focusOnMount}
          answered={answered}
          onViewChange={onViewChange}
        />
        <div className="sol-status">
          <p className="sol-status__body">
            {errorMessage(error, 'No pudimos cargar las solicitudes.')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <SolicitudesInbox
      items={items}
      table={table}
      focusHeading={focusOnMount}
      answered={answered}
      onViewChange={onViewChange}
      getItemHref={
        table ? (item) => `/solicitudes/${item.id}${search}` : undefined
      }
      onOpen={open}
      onQuote={open}
      onReject={open}
    />
  );
}
